export const tariffTypesTranslate = { 
  STANDARD: "стандарт", 
  DISCOUNT: "со скидкой" 
};
